import { useOutlet } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PeriodsList from 'modules/planning/components/PeriodsList'

import { PlanningPeriodNode } from 'modules/planning/types/queries'

const HeadcountPlanningPage = () => {
  const { navigation } = useNavigation()
  const outlet = useOutlet()

  const itemUrl = (item: PlanningPeriodNode) =>
    navigation.finance.financialWorkspace.headcountPlanning.periodDetail.fullPath({
      periodId: item.id,
    })

  return (
    <ResponsivePage.Body variant="fullscreen">
      {outlet ?? <PeriodsList periodType="headcount" itemUrl={itemUrl} />}
    </ResponsivePage.Body>
  )
}

export default HeadcountPlanningPage
